import type { ReactNode } from 'react'
import { Icon } from '@/components/brand/Brand'
import { SiteLink } from '@/components/ui/SiteLink'
import { siteConfig } from '@/config/site'
import { cx } from '@/lib/cx'

type ButtonVariant = 'signal' | 'ink' | 'line'

type ButtonLinkProps = {
  to: string
  variant: ButtonVariant
  small?: boolean
  className?: string
  children: ReactNode
}

const buttonClass = (variant: ButtonVariant, small?: boolean, className?: string) =>
  cx('btn', `btn-${variant}`, small && 'btn-sm', className)

/** A pill link with the trailing arrow. */
export const ButtonLink = ({ to, variant, small, className, children }: ButtonLinkProps) => (
  <SiteLink to={to} className={buttonClass(variant, small, className)}>
    {children}
    <Icon name="arrow" />
  </SiteLink>
)

/** Every "Book a call" on the site opens the booking page in a new tab. */
export const BookCallButton = ({ small, className }: { small?: boolean; className?: string }) => (
  <a className={buttonClass('signal', small, className)} href={siteConfig.bookingUrl} target="_blank" rel="noreferrer">
    Book a call
    <Icon name="arrow" />
  </a>
)
